import { mapGetters, mapActions } from 'vuex'
import { ErrorHelper } from '@/helpers/ErrorHelper'
import { CountryCacheMixin } from '@/mixins/Booking/CountryCacheMixin'
import { SelectedSiteIdMixin } from './SelectedSiteIdMixin'

export const FormatCountryCacheMixin = {
  mixins: [CountryCacheMixin, SelectedSiteIdMixin],
  data () {
    return {
      error: ''
    }
  },
  computed: {
    ...mapGetters('CountryFormats', [
      'findCountryFormatCache'
    ]),
    countryId () {
      return this.country ? this.country.countryId : ''
    },
    countryFormatQueryModel () {
      return {
        countryId: this.countryId
      }
    },
    countryFormatQueryModelValid () {
      return this.countryFormatQueryModel.countryId
    },
    countryFormatCache () {
      return this.findCountryFormatCache(this.countryId)
    },
    countryFormat () {
      return this.countryFormatCache ? this.countryFormatCache.value : null
    },
    loadingCountryFormat () {
      return this.countryFormatCache && this.countryFormatCache.loading
    },
    loadedCountryFormat () {
      return this.countryFormatCache && this.countryFormatCache.loaded
    }
  },
  watch: {
    countryId () {
      this.refreshCountryFormat()
    }
  },
  methods: {
    ...mapActions('CountryFormats', [
      'getCountryFormatBySiteId'
    ]),
    refreshCountryFormat () {
      if (!this.countryFormatCache || this.countryFormatCache.retry) {
        this.tryGetCountryFormatBySiteId()
      }
    },
    tryGetCountryFormatBySiteId () {
      const self = this
      if (!self.countryFormatQueryModelValid) {
        return
      }
      self.error = ''
      self.getCountryFormatBySiteId({ key: self.countryId, siteId: self.selectedSiteId, payload: self.countryFormatQueryModel })
        .catch(error => { self.error = ErrorHelper.getError(error) })
    }
  },
  created () {
    this.refreshCountryFormat()
  }
}
